/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Thu Jun 6 2019 3:16:54 PM
 *
 *******************************************************/
//@flow

import React, { Component } from 'react';
import { TextField } from '@shopify/polaris';
import { RenderLabelTooltip } from './forms/render-label-tooltip';

export class RenderTextField extends Component<Props> {
  render() {
    const {
      label,
      tooltip,
      name,
      value,
      type,
      placeholder,
      onChange,
      meta = {},
      anotherProps
    } = this.props;
    return (
      <div>
        <RenderLabelTooltip label={label} tooltip={tooltip} />
        <TextField
          id={name}
          value={value}
          type={type}
          onChange={onChange}
          placeholder={placeholder ? placeholder : ''}
          error={!!meta.error && !!meta.touched ? meta.error : ''}
          {...anotherProps}
        />
      </div>
    );
  }
}
